export default function(string) {
  return string.normalize("NFD").replace(/\p{Diacritic}/gu, "")
}
